import uuid from 'uuid/v4';
import { getStaticPagesList, getCompanyInfo } from '@/api';

export default {
  async init({ commit }) {
    try {
      const results = await Promise.all([
        getStaticPagesList(),
        getCompanyInfo(),
      ]);
      const [staticPages, companyInfo] = results;

      commit('setStaticPages', staticPages);
      commit('setCompanyInfo', companyInfo);
    } finally {
      commit('setInitialized', true);
    }
  },
  async hasStaticPage({ state }, slug) {
    let { staticPages } = state;

    if (!state.initialized) {
      staticPages = await getStaticPagesList();
    }

    return staticPages.some(staticPage => staticPage.slug === slug);
  },
  async getStaticPageIdBySlug({ state }, slug) {
    let { staticPages } = state;

    if (!state.initialized) {
      staticPages = await getStaticPagesList();
    }

    const page = staticPages.find(staticPage => staticPage.slug === slug);
    return page ? page.id : null;
  },
  cloneConfiguration({ state, commit }, configurationId) {
    const configurations = [...state.configurations];
    const configuration = configurations.find(x => x.id === configurationId);

    if (!configuration) {
      throw new Error(
        `Could not find configuration with id ${configurationId}`,
      );
    }

    const newConfiguration = JSON.parse(JSON.stringify(configuration));
    newConfiguration.id = uuid();

    commit('addConfiguration', newConfiguration);

    return newConfiguration;
  },
  openOrderQuoteModal({ commit, getters }) {
    const { hasConfigurations } = getters;
    const editing = getters['configurator/editing'];
    const completed = getters['configurator/completed'];

    if (!hasConfigurations) {
      return;
    }

    if (editing && !completed) {
      commit('openConfirmModal', {
        message: 'youAreInConfigurationEditMode',
        onConfirm: () => {
          commit('resetConfirmModal');
          commit('setOrderQuoteModalVisible', true);
        },
      });
    } else {
      commit('setOrderQuoteModalVisible', true);
    }
  },
};
